<mat-toolbar *ngIf="showToolbar" [color]="toolbarColor" class="view-toolbar mat-elevation-z2">
    <mat-toolbar-row  class="toolbar-header">
        <button mat-icon-button (click)="home()" type="button">
            <mat-icon>menu</mat-icon>
        </button>

        <h1 *ngIf="!isEditingTitle; else editTitleTemplate" (click)="editTitle()" class="toolbar-title" [class.editable-title]="editableTitle">
            {{ title }}
        </h1>

        <ng-template #editTitleTemplate>
            <mat-form-field class="title-edit-field" appearance="none">
                <input matInput
                    #titleInput
                    [formControl]="titleControl"
                    (blur)="submitTitle()"
                    (keydown.enter)="submitTitle()"
                    (keydown.escape)="isEditingTitle = false">
            </mat-form-field>
        </ng-template>

    </mat-toolbar-row>
    <mat-toolbar-row class="toolbar-tools">
        <ng-content select="[pv-view-search]"></ng-content>
        <ng-content select="[pv-view-tools]"></ng-content>
    </mat-toolbar-row>
</mat-toolbar>

<ng-content select="[pv-view-header]"></ng-content>

<div class="view-print-tools-spacer" *ngIf="printMode"></div>

<div class="view-body">
    <ng-content select="[pv-view-sidebar]"></ng-content>
    <ng-content select="[pv-view-body]"></ng-content>
    <ng-content select="[pv-view-sidebar-right]"></ng-content>
</div>

<div class="view-fabs" *ngIf="!printMode">
    <ng-content select="[pv-view-fab]"></ng-content>
</div>

<ng-content select="[pv-view-footer]" ></ng-content>

<mat-toolbar class="view-print-tools mat-elevation-z2" *ngIf="printMode">

    <button mat-flat-button (click)="togglePrintMode()">
        Close Preview
    </button>
    <button mat-flat-button color="primary" (click)="print()">
        Print
    </button>
</mat-toolbar>